import { funcAreaAPI, trngCourseAPI, employeeAPI } from "./api";

const cache = {
  funcAreas: null,
  _funcPromise: null,
  trngCourses: null,
  _trngPromise: null,
};

export const getFuncAreas = () => {
  if (cache.funcAreas) return Promise.resolve(cache.funcAreas);
  if (cache._funcPromise) return cache._funcPromise;

  cache._funcPromise = funcAreaAPI.getAll()
    .then((data) => {
      // const all = Array.isArray(data) ? data : [];
      // cache.funcAreas = all.filter(r => r.active_status === '1' || r.active_status === 1);
      cache.funcAreas=Array.isArray(data) ? data : [];
      cache._funcPromise = null;
      return cache.funcAreas;
    })
    .catch((err) => {
      cache._funcPromise = null;
      throw err;
    });

  return cache._funcPromise;
};

export const getTrngCourses = () => {
  if (cache.trngCourses) return Promise.resolve(cache.trngCourses);
  if (cache._trngPromise) return cache._trngPromise;

  cache._trngPromise = trngCourseAPI.getAll({ active_status: '1' })
    .then((data) => {
      cache.trngCourses = Array.isArray(data) ? data : [];
      cache._trngPromise = null;
      return cache.trngCourses;
    })
    .catch((err) => {
      cache._trngPromise = null;
      throw err;
    });

  return cache._trngPromise;
};

export const invalidateFuncAreas = () => {
  cache.funcAreas = null;
  cache._funcPromise = null;
};

export const invalidateTrngCourses = () => {
  cache.trngCourses = null;
  cache._trngPromise = null;
};

export const getAllTrngCourses = () => {
  if (cache._allTrngCourses) return Promise.resolve(cache._allTrngCourses);
  if (cache._allTrngPromise) return cache._allTrngPromise;

  cache._allTrngPromise = trngCourseAPI.getAll()
    .then((data) => {
      cache._allTrngCourses = Array.isArray(data) ? data : [];
      cache._allTrngPromise = null;
      return cache._allTrngCourses;
    })
    .catch((err) => {
      cache._allTrngPromise = null;
      throw err;
    });

  return cache._allTrngPromise;
};

export const invalidateAllTrngCourses = () => {
  cache._allTrngCourses = null;
  cache._allTrngPromise = null;
};

export const prefetchFuncAreas = () => { getFuncAreas().catch(() => { }); };
export const prefetchTrngCourses = () => { getTrngCourses().catch(() => { }); };

// Employee cache keyed by sal_code
const _empCache = {};
const _empPromises = {};

export const getEmployeeBySalCode = (sal_code) => {
  const key = String(sal_code);
  if (_empCache[key]) return Promise.resolve(_empCache[key]);
  if (_empPromises[key]) return _empPromises[key];

  _empPromises[key] = employeeAPI.getBySalCodes([key])
    .then((data) => {
      const emp = (Array.isArray(data) ? data : [])[0] || null;
      _empCache[key] = emp;
      delete _empPromises[key];
      return emp;
    })
    .catch((err) => {
      delete _empPromises[key];
      throw err;
    });

  return _empPromises[key];
};
